import type { CSSProperties } from "react";
import { Skel } from "../Skel";

// A paragraph's worth of lines, each one real line box tall (1lh, see
// .skel--text) so the text that replaces it lands on the same lines.
// Inherits the surrounding font size; no gap — the line box already
// carries the leading.
type Props = {
  lines?: number;
  /** Width of the last line, so the block reads as ragged prose. */
  lastWidth?: CSSProperties["width"];
};

export function SkelText({ lines = 3, lastWidth = "60%" }: Props) {
  return (
    <div aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <Skel key={i} variant="text" width={i === lines - 1 ? lastWidth : "100%"} />
      ))}
    </div>
  );
}
